// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
const {
  ARTICLE_UPDATED
} = require('client-v2/common/models/article/actions')
const contentAddModalActions = require('client-v2/common/containers/content-add-modal/actions')
const articleReducer = require('client-v2/common/models/article/reducer')
// Sibling imports
const {
  SHOW,
  HIDE,
  ARTICLE_FAILED,
  ARTICLE_LOADED,
  ARTICLE_LOADING,
  COLLECTIONS_FAILED,
  COLLECTIONS_LOADED,
  COLLECTIONS_LOADING,
  COLLECTION_CREATED,
  COLLECTION_UPDATED,
  CREATE_FAILED,
  CREATE_LOADED,
  CREATE_LOADING,
  SET_FILTER_TEXT,
  UNMIX_FAILED,
  UNMIX_LOADED,
  UNMIX_LOADING,
  UNMIX_PROMPT_TOGGLE
} = require('./actions')
const CollectionSelectModalRecord = require('./record')

// eslint-disable-next-line complexity
function collectionSelectModalReducer(
  state = new CollectionSelectModalRecord(),
  action
) {
  const { type, payload } = action
  if (type === SHOW) {
    return new CollectionSelectModalRecord()
    .setArticle(payload.article)
    .merge({
      isVisible: true,
      anchorId: payload.anchorId,
      url: payload.url,
      articleState: (
        payload.article
        ? FetchStateEnum.LOADED
        : FetchStateEnum.EMPTY
      )
    })
  }
  // All other actions should only matter after SHOW
  if (!state) {
    return state
  }
  switch (type) {
    // Visibility
    case HIDE:
    case contentAddModalActions.HIDE:
      return null
    // Controlled inputs
    case SET_FILTER_TEXT:
      return state.merge({
        filterText: payload
      })
    // Article
    case ARTICLE_FAILED:
      return state.merge({
        articleState: FetchStateEnum.FAILED
      })
    case ARTICLE_LOADED:
      return state
      .setArticle(payload)
      .merge({
        articleState: FetchStateEnum.LOADED
      })
    case ARTICLE_LOADING:
      return state.merge({
        articleState: FetchStateEnum.LOADING
      })
    case ARTICLE_UPDATED:
      return state.update('article', article => {
        return articleReducer(article, action)
      })
    // Collection Items
    case COLLECTION_CREATED:
      return state.createCollection(payload)
    case COLLECTION_UPDATED:
      return state.updateCollection(payload)
    // Collections
    case COLLECTIONS_FAILED:
      return state.merge({
        collectionsState: FetchStateEnum.FAILED
      })
    case COLLECTIONS_LOADED:
      return state
      .setCollections(payload)
      .merge({
        collectionsState: FetchStateEnum.LOADED
      })
    case COLLECTIONS_LOADING:
      return state.merge({
        collectionsState: FetchStateEnum.LOADING
      })
    // Create
    case CREATE_FAILED:
      return state.merge({
        createState: FetchStateEnum.FAILED
      })
    case CREATE_LOADED:
      return state
      .createCollection(payload)
      .merge({
        createState: FetchStateEnum.EMPTY,
        filterText: ''
      })
    case CREATE_LOADING:
      return state.merge({
        createState: FetchStateEnum.LOADING
      })
    // Unmix
    case UNMIX_FAILED:
      return state.merge({
        unmixState: FetchStateEnum.FAILED
      })
    case UNMIX_LOADED:
      return state.merge({
        unmixState: FetchStateEnum.EMPTY
      })
    case UNMIX_LOADING:
      return state.merge({
        unmixState: FetchStateEnum.LOADING
      })
    case UNMIX_PROMPT_TOGGLE:
      return state.merge({
        isUnmixPromptVisible: !!payload
      })
    default:
      return state
  }
}

module.exports = collectionSelectModalReducer
